export default {
  STRICTLY_NECESSARY: 'C0001',
  PERFORMANCE: 'C0002',
  FUNCTIONAL: 'C0003',
  TARGETING: 'C0004',
  SOCIAL_MEDIA: 'C0005',
  CAPTCHA: 'GR1',
  SMART_AD: 'HQ1',
  IPRESSO: 'IP1',
  SENTRY: 'SEN1',
};
